import React, { useState } from 'react';
import styles from './index.module.less';
import { inject } from 'mobx-react';
import { useInterval } from 'ahooks';

const Index = inject(
  'area',
  'app'
)((props) => {
  const { LANG, country, toggleAreaModal } = props.area;
  const [hideCountdown, setHideCountdown] = React.useState(false);
  const timer = React.useRef(null);
  const [time, setTime] = useState(10);
  const infoText = LANG['notAvailablePage.info'];
  const redirectText = React.useMemo(() => {
    if (hideCountdown) {
      return LANG['notAvailablePage.redirectTime'].replace(/__TIME__(.*)/, '');
    } else {
      return LANG['notAvailablePage.redirectTime'].replace('__TIME__', time);
    }
  }, [hideCountdown, time]);

  useInterval(() => {
    if (hideCountdown) return;
    if (time <= 0) {
      window.location.href = '/';
      return;
    }
    setTime(time - 1);
  }, 1000);

  return (
    <div className={styles.notAvailablePage}>
      <div className={styles.container}>
        <img
          className={styles.ic}
          src='https://res.insta360.com/static/c8705419964d11a71fba227d88a0b1b1/Union.svg'
          alt=''
        />
        <p>{infoText}</p>
        <a href='/' className={styles.redirect}>
          {redirectText}
        </a>
        {country && (
          <div className={styles.changArea}>
            <img
              width={12}
              height={12}
              src='https://res.insta360.com/static/ebb0946876d80acb1d895386047afb40/Vector.png'
              alt='country-icon'
            />
            <span
              onClick={() => {
                setHideCountdown(true);
                toggleAreaModal(true);
              }}
            >
              {`${country.name}（${country.language_text} / ${country.signal}${country.currency}）`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
});

export default Index;
